<template>
  <a-drawer
      :wrapClassName="$store.state.bgLight ? 'lightColor' : ''"
      :title='title'
      :width='1024'
      placement='right'
      :closable='!confirmLoading'
      :maskClosable='!confirmLoading'
      @close='close'
      :visible='visible'
  >
    <a-spin :spinning='confirmLoading'>
      <a-tabs defaultActiveKey='1' v-model="activeKey">
        <a-tab-pane tab='基本信息' key='1'>
          <a-form :form='form'>
            <a-row :gutter='24'>
              <a-col :md='12' :sm='24'>
                <a-form-item style='margin-left: 155px; display: flex; height: 200px'>
                  <a-upload
                      listType='picture-card'
                      class='avatar-uploader'
                      :showUploadList='false'
                      :action='uploadAction'
                      :data='{ isup: 1 }'
                      :headers='headers'
                      :beforeUpload='imgBeforeUpload'
                      @change='handleChange'
                      :disabled='disableSubmit'
                  >
                    <img
                        v-if='tempPicUrl'
                        v-decorator="['photo', {}]"
                        :src='photourl'
                        alt='图片'
                        style='height: 90px; width: 160px'
                    />
                    <div v-else>
                      <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                      <div class='ant-upload-text'>上传</div>
                    </div>
                  </a-upload>
                  <div style='color: red; font-weight: bold'>*请选择上传大小不超过1MB,比例为16:9的图片</div>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='编号(MN)'>
                  <a-input
                      placeholder='请输入编号(MN)'
                      v-decorator="['mn', validatorRules.mn]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='名称'>
                  <a-input
                      placeholder='请输入名称'
                      v-decorator="['name', validatorRules.name]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='通讯密码'>
                  <a-input
                      placeholder='请输入通讯密码'
                      v-decorator="['pw', validatorRules.pw]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='监测频率(分钟)'>
                  <a-input-number
                      style='width: 100%'
                      placeholder='请输入监测频率(分钟)'
                      v-decorator="['commSum', validatorRules.commSum]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='站点类型'>
                  <a-select
                      mode='single'
                      style='width: 100%'
                      placeholder='请选择站点类型'
                      v-decorator="['category', validatorRules.category]"
                      :disabled='disableSubmit'
                      allowClear
                      optionFilterProp='children'
                      showSearch
                  >
                    <a-select-option v-for='(item, Index) in categoryList' :key='Index' :value='item.value'
                    >{{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='环境标准'>
                  <a-tree-select
                      style='width: 100%'
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      :treeData='StandardListOptions'
                      :disabled='disableSubmit'
                      v-decorator="['standardOptionId', validatorRules.standardOptionId]"
                      placeholder='请选择环境标准'
                      :allowClear='true'
                      show-search
                      treeNodeFilterProp='title'
                  >
                    <template slot='title' slot-scope='{ title }'>ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col>

              <!-- <a-col :md="12" v-show="false" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运营中心">
                  <a-tree-select
                    style="width: 100%"
                    :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    :treeData="deptTree"
                    :disabled="true"
                    v-decorator="['deptId', validatorRules.deptId]"
                    placeholder="请选择运营中心"
                  >
                    <template slot="title" slot-scope="{ title }">ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col> -->

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='责任人'>
                  <a-tree-select
                      style='width: 100%'
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      :treeData='userTree'
                      :disabled='disableSubmit'
                      v-decorator="['userId', validatorRules.userId]"
                      placeholder='请选择责任人'
                      :allowClear='true'
                      show-search
                      treeNodeFilterProp='title'
                  >
                    <template slot='title' slot-scope='{ title }'>ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24' v-if="st != '52'">
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='水体流域'>
                  <a-tree-select
                      style='width: 100%'
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      :treeData='riverTree'
                      v-decorator="['riverId', validatorRules.riverId]"
                      :disabled='disableSubmit'
                      placeholder='请选择水体流域'
                      :allowClear='true'
                      show-search
                      treeNodeFilterProp='title'
                  >
                    <template slot='title' slot-scope='{ title }'>ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24' v-if="st == '52'">
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='所属管网'>
                  <a-select
                      mode='single'
                      style='width: 100%'
                      placeholder='请选择管网'
                      v-decorator="['pipeId', {}]"
                      :disabled='disableSubmit'
                      allowClear
                      optionFilterProp='children'
                      showSearch
                  >
                    <a-select-option v-for='(wh, whIndex) in pipeList' :key='whIndex' :value='wh.id'
                    >{{ wh.title }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='行政区域'>
                  <a-tree-select
                      style='width: 100%'
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      :treeData='areaTree'
                      v-decorator="['areaId', validatorRules.areaId]"
                      :disabled='disableSubmit'
                      placeholder='请选择行政区域'
                      show-search
                      treeNodeFilterProp='title'
                  >
                    <template slot='title' slot-scope='{ title }'>ABC{{ title }}</template>
                  </a-tree-select>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='监测企业'>
                  <a-select
                      mode='single'
                      style='width: 100%'
                      placeholder='请选择监测企业'
                      v-decorator="['companyId', validatorRules.companyId]"
                      :disabled='disableSubmit'
                      allowClear
                      optionFilterProp='children'
                      showSearch
                  >
                    <a-select-option v-for='(wh, whIndex) in companyList' :key='whIndex' :value='wh.id'
                    >{{ wh.companyName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item style='margin-bottom: 18px' :labelCol='labelCol' :wrapperCol='wrapperCol' label='坐标'>
                  <a-row>
                    <a-col :span='9' :gutter='10'>
                      <a-input
                          @click='longitudeChange'
                          readonly
                          v-decorator="['longitude', validatorRules.longitude]"
                          :disabled='disableSubmit'
                      />
                    </a-col>
                    <a-col :span='2' :gutter='2' style='text-align: center'>-</a-col>
                    <a-col :span='9' :gutter='10'>
                      <a-input
                          @click='longitudeChange'
                          readonly
                          v-decorator="['latitude', validatorRules.latitude]"
                          :disabled='disableSubmit'
                      />
                    </a-col>
                    <a-col :span='4' :gutter='2'>
                      <a-icon
                          @click='longitudeChange'
                          :style="{ fontSize: '28px', color: '#08c', marginTop: '6px' }"
                          type='environment'
                          v-if='!disableSubmit'
                      />
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='数据审核状态'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      :defaultState='true'
                      dictCode='site_check_status'
                      v-decorator="['checkStatus', validatorRules.checkStatus]"
                      placeholder='请选择数据审核状态'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='状态'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      :defaultState='true'
                      dictCode='valid_status'
                      v-decorator="['status', validatorRules.status]"
                      placeholder='请输入状态'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='排序号'>
                  <a-input-number style='width: 100%' v-decorator="['sort', {}]" :min='0' :disabled='disableSubmit'/>
                </a-form-item>
              </a-col>
              <a-col :md='24' :sm='24'>
                <a-form-item :labelCol='{ span: 4 }' :wrapperCol='{ span: 20 }' label='详细地址'>
                  <a-textarea
                      :rows='2'
                      placeholder='请输入详细地址'
                      v-decorator="['addr', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
              <a-col :md='24' :sm='24'>
                <a-form-item :labelCol='{ span: 4 }' :wrapperCol='{ span: 20 }' label='站点介绍'>
                  <a-textarea
                      :rows='2'
                      placeholder='请输入站点介绍'
                      v-decorator="['remark', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>

        <a-tab-pane tab='监测因子' key='2'>
          <a-row v-if='!disableSubmit' style='padding-bottom: 10px'>
            <a-col :span='3' :gutter='2'>
              <a-button @click='addTable' type='primary' icon='plus'>新增</a-button>
            </a-col>
            <a-col :span='8'>
              <site-factor-sync :siteId='model.id' :factors='dataFactor' :disabled='confirmLoading || !networkStatus'
                                @busy='confirmLoading = $event' @synced='dataFactor = $event' />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='24' :gutter='24'>
              <a-table :columns='columnsFactor' :dataSource='dataFactor' :pagination='false' bordered>
                <template :slot="'factorId'" slot-scope='text, record, index'>
                  <div :key="'factorId'">
                    <a-select
                        showSearch
                        :allowClear='false'
                        placeholder='请选择监测因子'
                        optionFilterProp='children'
                        v-model='text'
                        style='width: 100%'
                        @change="handleChangeFactorTable($event, record.key, 'factorId')"
                        :filterOption='filterOption'
                        :disabled='disableSubmit || !record.editable'
                    >
                      <a-select-option v-for='(item, key) in factorOptions' :key='key' :value='item.id'
                      >{{ item.title }}({{ item.code }})
                      </a-select-option>
                    </a-select>
                    <!--                              <template v-else>{{text}}</template>-->
                  </div>
                </template>
                <!--限制类型-->
                <template :slot="'restriction'" slot-scope='text, record, index'>
                  <div :key="'restriction'">
                    <j-dict-select-tag
                        :triggerChange='true'
                        dictCode='limit_type'
                        placeholder='请输入限制类型'
                        :disabled='disableSubmit || !record.editable'
                        v-model='text'
                        :allowClear='false'
                        @change="handleChangeRestriction($event, record.key, 'restriction')"
                        showSearch
                        style='width: 100%'
                    ></j-dict-select-tag>
                    <!--                              <template v-else>{{text}}</template>-->
                  </div>
                </template>
                <!--最小值-->
                <template :slot="'lower'" slot-scope='text, record, index'>
                  <div :key="'lower'">
                    <a-input
                        v-if='record.editable && record.lower_status'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeFactorTable(e.target.value, record.key, 'lower')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>
                <!--最大值-->
                <template :slot="'upper'" slot-scope='text, record, index'>
                  <div :key="'upper'">
                    <a-input
                        v-if='record.editable && record.upper_status'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeFactorTable(e.target.value, record.key, 'upper')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>
                <!--恒值次数-->
                <template :slot="'constantNum'" slot-scope='text, record, index'>
                  <div :key="'constantNum'">
                    <a-input
                        v-if='record.editable'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeFactorTable(e.target.value, record.key, 'constantNum')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>
                <!--监测频率(分钟)-->
                <template :slot="'monitorNum'" slot-scope='text, record, index'>
                  <div :key="'monitorNum'">
                    <a-input
                        v-if='record.editable'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeFactorTable(e.target.value, record.key, 'monitorNum')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>
                <!--排序-->
                <template :slot="'sort'" slot-scope='text, record, index'>
                  <div :key="'sort'">
                    <a-input
                        v-if='record.editable'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeFactorTable(e.target.value, record.key, 'sort')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>

                <template slot='operation' slot-scope='text, record, index'>
                  <div class='editable-row-operations' v-if='!disableSubmit'>
                    <!--                              <span v-if="record.editable">-->
                    <!--                                <a @click="() => saveTable(record.key)">保存</a>-->
                    <!--                                <a-popconfirm-->
                    <!--                                  title="是否确认取消?"-->
                    <!--                                  @confirm="() => cancelTable(record.key)"-->
                    <!--                                >-->
                    <!--                                  <a style="margin-left:10px;">取消</a>-->
                    <!--                                </a-popconfirm>-->
                    <!--                              </span>-->
                    <!--                          <span v-else>-->
                    <!--                                <a @click="() => editTable(record.key)" style="margin-left:10px;">编辑</a>-->
                    <a-popconfirm title='是否确认删除?' @confirm='() => delFactorTable(record.key)'>
                      <a style='margin-left: 10px'>删除</a>
                    </a-popconfirm>
                    <!--                              </span>-->
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane v-if="false" tab='站点参数' key='3'>
          <!--                <a-row v-if="!disableSubmit">-->
          <!--                  <a-col :span="3" :gutter="2">-->
          <!--                    <a-button style="margin-bottom: 10px" @click="addTable" type="primary" icon="plus">新增</a-button>-->
          <!--                  </a-col>-->
          <!--                </a-row>-->
          <a-row>
            <a-col :span='24' :gutter='24'>
              <a-table :columns='columnsParam' :dataSource='dataParam' :pagination='false' bordered>
                <template :slot="'name'" slot-scope='text, record, index'>
                  <div :key="'name'">
                    <template>{{ text }}</template>
                  </div>
                </template>

                <template :slot="'val'" slot-scope='text, record, index'>
                  <div :key="'val'">
                    <a-input
                        v-if='record.editable'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeTable(e.target.value, record.key, 'val')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>

                <template :slot="'sort'" slot-scope='text, record, index'>
                  <div :key="'sort'">
                    <a-input
                        v-if='record.editable'
                        style='margin: -5px 0'
                        :value='text'
                        @change="(e) => handleChangeTable(e.target.value, record.key, 'sort')"
                    />
                    <template v-else>{{ text }}</template>
                  </div>
                </template>

                <template slot='operation' slot-scope='text, record, index'>
                  <div class='editable-row-operations' v-if='!disableSubmit'>
                    <!--                          <span v-if="record.editable">-->
                    <!--                            <a @click="() => saveTable(record.key)">保存</a>-->
                    <!--                            <a-popconfirm title='是否确认取消?' @confirm="() => cancelTable(record.key)">-->
                    <!--                              <a style="margin-left:10px;">取消</a>-->
                    <!--                            </a-popconfirm>-->
                    <!--                          </span>-->
                    <!--                          <span v-else>-->
                    <!--                            <a @click="() => editTable(record.key)" style="margin-left:10px;">编辑</a>-->
                    <a-popconfirm title='是否确认删除?' @confirm='() => delTable(record.key)'>
                      <a style='margin-left: 10px'>删除</a>
                    </a-popconfirm>

                    <!--                          </span>-->
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane v-if="false" tab='八方位图' key='4'>
          <a-row :gutter='24'>
            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('northwest', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    v-if='octagonalUrl.northwestUrl'
                    :src="getAvatarView('northwest')"
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>

            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('north', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    v-if='octagonalUrl.northUrl'
                    :src="getAvatarView('north')"
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>

            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('northeast', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    :src="getAvatarView('northeast')"
                    v-if='octagonalUrl.northeastUrl'
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
          <a-row :gutter='24'>
            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('west', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    :src="getAvatarView('west')"
                    v-if='octagonalUrl.westUrl'
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>

            <a-col :md='8' :sm='24'>
              <div style='height: 250px; width: 100%'>
                <img
                    src='@/assets/others/index/site_picture.png'
                    style='width: 100%; height: 250px; background: white'
                />
              </div>
            </a-col>

            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('east', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    :src="getAvatarView('east')"
                    v-if='octagonalUrl.eastUrl'
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
          <a-row :gutter='24'>
            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('southwest', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    :src="getAvatarView('southwest')"
                    v-if='octagonalUrl.southwestUrl'
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>

            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('south', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    :src="getAvatarView('south')"
                    v-if='octagonalUrl.southUrl'
                    alt='图片'
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>

            <a-col :md='8' :sm='24'>
              <a-upload
                  listType='picture-card'
                  class='avatar-uploader picture'
                  :showUploadList='false'
                  :action='uploadAction'
                  :data='{ isup: 1 }'
                  :headers='headers'
                  :beforeUpload='beforeUpload'
                  @change="handleChangeComm('southeast', $event)"
                  :disabled='disableSubmit'
              >
                <img
                    v-if='octagonalUrl.southeastUrl'
                    alt='图片'
                    :src="getAvatarView('southeast')"
                    style='height: 250px; width: 100%'
                />
                <div v-else>
                  <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
                  <div class='ant-upload-text'>上传</div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane v-if="false" tab='内景图' key='5'>
          <iws-upload
              ref='iwupload'
              :options="{ btnText: '选择文件' }"
              :disableSubmit='disableSubmit'
              filesrc='site_info_file'
              :srcid='this.model.id'
          ></iws-upload>
        </a-tab-pane>

        <a-tab-pane tab='站点成员' key='6'>
          <a-row v-if='!disableSubmit' style='padding-bottom: 10px'>
            <a-col :span='2' :gutter='2'>
              <a-button @click='addTable3' type='primary' icon='plus'>新增</a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='24' :gutter='24'>
              <a-table :columns='columnsUser' :dataSource='dataUser' :pagination='false' bordered>
                <template slot='userId' slot-scope='text, record, index'>
                  <a-tree-select
                      show-search
                      treeNodeFilterProp='title'
                      style='width: 100%'
                      :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                      :treeData='userTree'
                      :disabled='disableSubmit'
                      v-model='record.userId'
                      placeholder='请选择责任人'
                  >
                    <template slot='title' slot-scope='{ title }'> ABC{{ title }}</template>
                  </a-tree-select>
                </template>
                <template v-if="st != '31'" slot='siteRole' slot-scope='text, record, index'>
                  <j-dict-select-tag
                      style='width: 100%'
                      dictCode='site_role'
                      v-model='record.siteRole'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </template>

                <template v-if="st == '31'" slot='siteRole' slot-scope='text, record, index'>
                  <j-dict-select-tag
                      style='width: 100%'
                      dictCode='site_role_st31'
                      v-model='record.siteRole'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </template>

                <template slot='status' slot-scope='text, record, index'>
                  <j-dict-select-tag
                      style='width: 100%'
                      dictCode='enable_disable_status'
                      v-model='record.status'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </template>
                <template slot='operation' slot-scope='text, record, index'>
                  <div class='editable-row-operations' v-if='!disableSubmit'>
                    <span v-if='record.editable'>
                      <a @click='() => saveTable3(record.key)'>保存</a>
                      <a-popconfirm title='是否确认取消?' @confirm='() => cancelTable3(record.key)'>
                        <a style='margin-left: 10px'>取消</a>
                      </a-popconfirm>
                    </span>
                    <span v-else>
                      <a @click='() => editTable3(record.key)' style='margin-left: 10px'>编辑</a>
                      <a-popconfirm title='是否确认删除?' @confirm='() => delTable3(record.key)'>
                        <a style='margin-left: 10px'>删除</a>
                      </a-popconfirm>
                    </span>
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane v-if="false" tab='生产规则' key='7'>
          <a-row v-if='!disableSubmit' style='padding-bottom: 10px'>
            <a-col :span='2' :gutter='2'>
              <a-button @click='addTable7' type='primary' icon='plus'>新增</a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span='24' :gutter='24'>
              <a-table :columns='produceRule' :dataSource='dataProduceRule' :pagination='false' bordered>

                <!--命令编码-->
                <template :slot="'cn'" slot-scope='text, record, index'>
                  <div :key="'cn'">
                    <a-input
                        :disabled='disableSubmit'
                        v-model='record.cn'
                    />
                  </div>
                </template>

                <!--配置参数-->
                <template :slot="'config'" slot-scope='text, record, index'>
                  <div :key="'config'">
                    <a-textarea
                        style='min-height: 250px'
                        :disabled='disableSubmit'
                        v-model='record.config'
                    />
                  </div>
                </template>

                <!--状态-->
                <template slot='status' slot-scope='text, record, index'>
                  <j-dict-select-tag
                      style='width: 100%'
                      dictCode='enable_disable_status'
                      v-model='record.status'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </template>

                <!--排序-->
                <template :slot="'sort'" slot-scope='text, record, index'>
                  <div :key="'sort'">
                    <a-input-number
                        :disabled='disableSubmit'
                        v-model='record.sort'
                    />
                  </div>
                </template>

                <template slot='operation' v-if='!disableSubmit' slot-scope='text, record, index'>
                  <div class='editable-row-operations' v-if='!disableSubmit'>
                          <span>
                            <a-popconfirm title='是否确认删除?' @confirm='() => delTable7(record.key)'>
                              <a style='margin-left: 10px'>删除</a>
                            </a-popconfirm>
                          </span>
                  </div>
                </template>
              </a-table>
            </a-col>
          </a-row>
        </a-tab-pane>

        <a-tab-pane v-if="false && st!=31" tab='运维档案' key='8' forceRender>
          <a-form :form='devopsForm'>
            <a-row :gutter='24'>
              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='控制级别'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      dictCode='control_level'
                      v-decorator="['controlLevel', {}]"
                      placeholder='请选择控制级别'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='水体类型'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      dictCode='river_type'
                      v-decorator="['riverType', {}]"
                      placeholder='请选择水体类型'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='断面名称'>
                  <a-input
                      placeholder='请输入断面名称'
                      v-decorator="['sectionName', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='点位编码'>
                  <a-input
                      placeholder='请输入点位编码'
                      v-decorator="['pointCoding', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='运维单位'>
                  <a-input
                      placeholder='请输入运维单位'
                      v-decorator="['devopsUnit', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='站房面积'>
                  <a-input-number
                      style='width: 100%'
                      placeholder='请输入站房面积'
                      v-decorator="['houseArea', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='站房类型'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      dictCode='house_type'
                      v-decorator="['houseType', {}]"
                      placeholder='请选择站房类型'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='采水方式'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      dictCode='water_collection'
                      v-decorator="['waterCollection', {}]"
                      placeholder='请选择采水方式'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='通信方式'>
                  <j-dict-select-tag
                      :triggerChange='true'
                      dictCode='communication_type'
                      v-decorator="['communication', {}]"
                      placeholder='请选择通信方式'
                      :disabled='disableSubmit'
                  >
                  </j-dict-select-tag>
                </a-form-item>
              </a-col>

              <a-col :md='12' :sm='24'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label="投运时间">
                  <a-date-picker
                      ref='mixTime'
                      style='width: 100%'
                      placeholder='请选择投运时间'
                      format='YYYY-MM-DD HH:mm:ss'
                      v-decorator="['operationTime', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='24' :sm='24'>
                <a-form-item :labelCol='{ span: 4 }' :wrapperCol='{ span: 20 }' label='上下游污染情况'>
                  <a-textarea
                      :rows='2'
                      placeholder='请输入上下游污染情况'
                      v-decorator="['pollutionSituation', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>

              <a-col :md='24' :sm='24'>
                <a-form-item :labelCol='{ span: 4 }' :wrapperCol='{ span: 20 }' label='支流汇入情况'>
                  <a-textarea
                      :rows='2'
                      placeholder='请输入支流汇入情况'
                      v-decorator="['branchImport', {}]"
                      :disabled='disableSubmit'
                  />
                </a-form-item>
              </a-col>
            </a-row>

            <a-row style='margin-top: 10px'>
              <a-col>
                <iws-upload
                    ref='iwupload1'
                    :options="{ btnText: '上传' }"
                    :disableSubmit='disableSubmit'
                    filesrc='site_info_devops'
                    :srcid='this.devopsColumns.id'
                >
                </iws-upload>
              </a-col>
            </a-row>
          </a-form>
        </a-tab-pane>
      </a-tabs>

      <div class='drawer-msg' v-show='disableSubmit'>
        <a-row>
          <a-col :span='12'> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}）</a-col>
          <a-col :span='12'> 最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}）</a-col>
        </a-row>
      </div>
    </a-spin>
    <map-get-point :mapCenter='mapCenter' ref='mapForm' @mapChange='coordinateOk'></map-get-point>
    <div class='drawer-tool' v-show='!disableSubmit'>
      <a-button icon='close' :disabled='confirmLoading' @click='handleCancel'>取消</a-button>
      <a-button type='primary' :disabled='!networkStatus || confirmLoading' icon='check' @click='handleOk'>确定</a-button>
    </div>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {ModalFormMixin} from '@/mixins/ModalFormMixin'
import {getAction, httpAction} from '@/api/manage'
import MapGetPoint from '@/components/Map/MapGetPoint'
import SiteFactorSync from '@/views/base/modules/SiteFactorSync.vue'
import Vue from 'vue'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import pick from 'lodash.pick'
import {
  duplicateCheckData,
  queryAreaTreeList,
  queryFactorList,
  queryRiverTreeList,
  queryStandardTreeList,
  queryUserTreeList
} from '@/api/api'
import IwsUpload from '@comp/upload/IwsUpload'


const columnsParam = [
  {
    title: '参数名称',
    dataIndex: 'name',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'name'
    }
  },
  {
    title: '参数值',
    dataIndex: 'val',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'val'
    }
  },
  {
    title: '序号',
    align: 'center',
    dataIndex: 'sort',
    width: '10%',
    scopedSlots: {
      customRender: 'sort'
    }
  },
  {
    title: '操作',
    width: '10%',
    align: 'center',
    dataIndex: 'operation',
    scopedSlots: {
      customRender: 'operation'
    }
  }
]

const dataParam = []
// PS相关的KEY不能为title关键字
const addDataIndex = 0

const columnsFactor = [
  {
    title: '监测因子',
    dataIndex: 'factorId',
    align: 'center',
    width: '25%',
    scopedSlots: {
      customRender: 'factorId'
    }
  },
  {
    title: '限制类型',
    dataIndex: 'restriction',
    align: 'center',
    width: '15%',
    scopedSlots: {
      customRender: 'restriction'
    }
  },
  {
    title: '最小值',
    dataIndex: 'lower',
    width: '15%',
    align: 'center',
    scopedSlots: {
      customRender: 'lower'
    }
  },
  {
    title: '最大值',
    align: 'center',
    dataIndex: 'upper',
    width: '15%',
    scopedSlots: {
      customRender: 'upper'
    }
  },
  {
    title: '恒值次数',
    dataIndex: 'constantNum',
    align: 'center',
    width: '10%',
    scopedSlots: {
      customRender: 'constantNum'
    }
  },
  {
    title: '监测频率(分钟)',
    dataIndex: 'monitorNum',
    align: 'center',
    width: '10%',
    scopedSlots: {
      customRender: 'monitorNum'
    }
  },
  {
    title: '序号',
    dataIndex: 'sort',
    align: 'center',
    width: '10%',
    scopedSlots: {
      customRender: 'sort'
    }
  },
  {
    title: '操作',
    align: 'center',
    width: '15%',
    dataIndex: 'operation',
    scopedSlots: {
      customRender: 'operation'
    }
  }
]

const columnsUser = [
  {
    title: '姓名',
    dataIndex: 'userId',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'userId'
    }
  },
  {
    title: '角色',
    dataIndex: 'siteRole',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'siteRole'
    }
  },
  {
    title: '预警推送',
    dataIndex: 'status',
    align: 'center',
    width: '20%',
    scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    scopedSlots: {
      customRender: 'operation'
    }
  }
]

const produceRule = [
  {
    title: '命令编码',
    dataIndex: 'cn',
    align: 'center',
    width: '15%',
    scopedSlots: {
      customRender: 'cn'
    }
  },
  {
    title: '配置参数',
    dataIndex: 'config',
    align: 'center',
    width: '30%',
    scopedSlots: {
      customRender: 'config'
    }
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'center',
    width: '15%',
    scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '排序号',
    dataIndex: 'sort',
    align: 'center',
    width: '15%',
    scopedSlots: {
      customRender: 'sort'
    }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    align: 'center',
    width: '15%',
    scopedSlots: {
      customRender: 'operation'
    }
  }
]

const dataFactor = []
const dataUser = []
const dataProduceRule = []

// PS相关的KEY不能为title关键字
const addFactorDataIndex = 0
const addUserDataIndex = 0
const addProduceRuleIndex = 0

export default {
  name: 'SiteInfoModal',
  components: {
    MapGetPoint,
    IwsUpload,
    SiteFactorSync
  },
  mixins: [ModalFormMixin],
  data() {
    this.cacheData = dataParam.map((item) => ({
      ...item
    }))
    this.cacheFactorData = dataFactor.map((item) => ({
      ...item
    }))
    this.cacheUserData = dataUser.map((item) => ({
      ...item
    }))
    this.produceRuleData = dataProduceRule.map((item) => ({
      ...item
    }))


    return {
      activeKey: '1',
      dataParam,
      columnsParam,
      columnsUser,
      produceRule,
      addDataIndex,
      dataFactor,
      dataUser,
      dataProduceRule,
      columnsFactor,
      addFactorDataIndex,
      addUserDataIndex,
      addProduceRuleIndex,
      upper_status: true,
      lower_status: true,
      factorOptions: [],
      devopsForm: this.$form.createForm(this),
      mapCenter: [],
      riverTree: [],
      areaTree: [],
      deptTree: [],
      userTree: [],
      st: '',
      categoryList: [],
      companyList: [],
      pipeList: [],
      octagonal: {},
      octagonalUrl: {},
      StandardListOptions: [],
      title: '污水站点表单',
      tableName: 'site_info',
      form_fields: [
        'mn',
        'companyId',
        'pipeId',
        'name',
        'pw',
        'commSum',
        'category',
        'standardOptionId',
        'userId',
        'riverId',
        'areaId',
        'longitude',
        'latitude',
        'addr',
        'photo',
        'checkStatus',
        'status',
        'sort',
        'remark',
        'st'
      ],
      form_fields_time: [],
      devopsForm_fields: [
        'controlLevel',
        'riverType',
        'sectionName',
        'pointCoding',
        'devopsUnit',
        'houseArea',
        'houseType',
        'waterCollection',
        'communication',
        'pollutionSituation',
        'branchImport'
      ],
      devopsForm_fields_time: ['operationTime'],
      devopsColumns: {},
      validatorRules: {
        mn: {
          rules: [
            {
              required: true,
              message: '请输入编号!'
            },
            {
              validator: this.validateMN,
            },
          ]
        },
        name: {
          rules: [
            {
              required: true,
              message: '请输入名称!'
            }
          ]
        },
        pw: {
          rules: [
            {
              required: true,
              message: '请输入通讯密码!'
            }
          ]
        },
        areaId: {
          rules: [
            {
              required: true,
              message: '请选择行政区域!'
            }
          ]
        },
        commSum: {
          rules: [
            {
              required: true,
              message: '请输入每日监测数量!'
            }
          ]
        },
        // standardOptionId: { rules: [{ required: true, message: '请选择环境标准!' }] },
        longitude: {
          rules: [
            {
              required: true,
              message: '请输入经度!'
            }
          ]
        },
        latitude: {
          rules: [
            {
              required: true,
              message: '请输入纬度!'
            }
          ]
        },
        checkStatus: {
          rules: [
            {
              required: true,
              message: '请输入数据审核状态!'
            }
          ]
        },
        status: {
          rules: [
            {
              required: true,
              message: '请输入状态!'
            }
          ]
        }
      },
      headers: {},
      uploadLoading: false,
      picUrl: '',
      tempPicUrl: '',
      photourl: '',
      uploadFile: {},
      url: {
        company: '/site/company',
        pipe: '/sys/pipe/system',
        picture: '/site/picture/find/',
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      }
    }
  },
  props: ['pagePath', 'st'],
  created() {
    const token = Vue.ls.get(ACCESS_TOKEN)
    this.headers = {
      'X-Access-Token': token
    }
  },
  computed: {
    uploadAction: function () {
      return this.url.fileUpload
    }
  },
  methods: {

    validateMN(rule, value, callback) {
      var params = {
        tableName: 'site_info',
        fieldName: 'mn',
        fieldVal: value,
        dataId: this.siteId,
      }
      duplicateCheckData(params).then((res) => {
        if (res.success) {
          callback()
        } else {
          callback("该MN【" + value + "】已被站点：" + res.result + "使用")
        }
      })
    },
    queryCompanyList() {
      let params = {
        pageSize: -1
      }
      getAction(this.url.company, params).then((res) => {
        if (res.success) {
          this.companyList = res.result.records
        }
      })
    },
    queryPipeList() {
      getAction(this.url.pipe).then((res) => {
        if (res.success) {
          this.pipeList = res.result.records
        }
      })
    },
    queryCategoryList() {
      getAction('/sys/dict/getDictItems/site_st' + this.st + '_category').then((res) => {
        if (res.success) {
          this.categoryList = res.result
        }
      })
    },
    queryPicture() {
      getAction(this.url.picture + this.model.id).then((res) => {
        if (res.success) {
          this.octagonal = res.result == null ? this.octagonal : res.result
          if (res.result != null) {
            if (this.octagonal.northwest && this.octagonal.northwest != '') {
              this.octagonalUrl.northwestUrl = true
            }
            if (this.octagonal.north && this.octagonal.north != '') {
              this.octagonalUrl.northUrl = true
            }
            if (this.octagonal.northeast && this.octagonal.northeast != '') {
              this.octagonalUrl.northeastUrl = true
            }
            if (this.octagonal.west && this.octagonal.west != '') {
              this.octagonalUrl.westUrl = true
            }
            if (this.octagonal.east && this.octagonal.east != '') {
              this.octagonalUrl.eastUrl = true
            }
            if (this.octagonal.southwest && this.octagonal.southwest != '') {
              this.octagonalUrl.southwestUrl = true
            }
            if (this.octagonal.south && this.octagonal.south != '') {
              this.octagonalUrl.southUrl = true
            }
            if (this.octagonal.southeast && this.octagonal.southeast != '') {
              this.octagonalUrl.southeastUrl = true
            }
          }
        }
      })
    },
    edit(record) {
      this.activeKey = '1'
      this.photourl = ''
      this.tempPicUrl = ''
      this.octagonal = {
        northwest: '',
        north: '',
        northeast: '',
        west: '',
        east: '',
        southwest: '',
        south: '',
        southeast: ''
      }
      this.octagonalUrl = {
        northwestUrl: false,
        northUrl: false,
        northeastUrl: false,
        westUrl: false,
        eastUrl: false,
        southwestUrl: false,
        southUrl: false,
        southeastUrl: false
      }
      this.mapCenter = []
      this.dataParam = []
      this.dataProduceRule = []
      this.addDataIndex = 1
      this.form.resetFields()
      this.devopsForm.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.loadTree()
      this.queryCompanyList()
      this.queryPipeList()
      this.queryCategoryList()
      this.queryDictByCode()
      this.devopsColumns = {}
      this.dataFactor = []
      this.siteId = record.id
      if (typeof record.id != 'undefined') {
        this.loadSiteFactor() // 加载站点因子
        this.loadSiteUser() // 加载站点因子
        this.queryPicture() //加载八方图
        this.loadProduceRule() // 加载生产判断
        this.loadSiteDevops() //加载运维档案
      }
      this.$nextTick(() => {
        var that = this
        that.form.setFieldsValue(pick(that.model, that.form_fields))
        //时间格式化
        let timeVal = {}
        that.form_fields_time.forEach((item, index) => {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null
        })
        that.form.setFieldsValue(timeVal)
        if (this.model.photo) this.tempPicUrl = this.model.photo
        this.photourl = this.getImageView()
        if (typeof this.model.longitude != 'undefined' && typeof this.model.latitude != 'undefined') {
          this.mapCenter.push(this.model.longitude)
          this.mapCenter.push(this.model.latitude)
        }
        if (that.$refs.iwupload) {
          that.$refs.iwupload.loadUploadFiles() //加载文件上传
        }
      })
    },
    loadSiteFactor() {
      //获取站点因子
      let that = this
      let params = {
        pageNo: 1,
        pageSize: 10000,
        siteId: this.model.id
      }
      getAction('/site/info/factor', params).then((res) => {
        if (res.success) {
          let paramList = []
          for (let i = 0; i < res.result.records.length; i++) {
            let param = res.result.records[i]
            param.key = param.id
            param.editable = true
            // 判断限制类型决定是否显示最大值、最小值
            if (param.restriction == 2 || param.restriction == 4) {
              param.upper_status = false
              param.lower_status = true
            } else if (param.restriction == 3 || param.restriction == 5) {
              param.upper_status = true
              param.lower_status = false
            } else if (param.restriction == 1) {
              param.upper_status = true
              param.upper_status = true
            } else if (param.restriction == '') {
              param.upper_status = false
              param.upper_status = false
            }
            paramList.push(param)
          }
          that.dataFactor = paramList
        }
      })
    },
    loadSiteUser() {
      //获取站点因子
      let that = this
      let params = {
        pageNo: 1,
        pageSize: 10000,
        siteId: this.model.id
      }
      getAction('/site/info/user', params).then((res) => {
        if (res.success) {
          let paramList = []
          for (let i = 0; i < res.result.records.length; i++) {
            let param = res.result.records[i]
            param.key = param.id
            paramList.push(param)
          }
          that.dataUser = paramList
        }
      })
    },

    loadSiteDevops() {
      //获取站点因子
      let that = this
      let params = {
        siteId: this.model.id
      }
      getAction('/site/info/devops/getBySite', params).then((res) => {
        if (res.success) {
          that.devopsColumns = Object.assign({}, res.result)
          that.devopsForm.setFieldsValue(pick(that.devopsColumns, that.devopsForm_fields))
          let timeVals = {}
          that.devopsForm_fields_time.forEach((item, index) => {
            timeVals[item] = that.devopsColumns[item] ? moment(that.devopsColumns[item]) : null
          })
          that.devopsForm.setFieldsValue(timeVals)
        }
      })
    },

    loadProduceRule() {
      var that = this
      let params = {
        pageNo: 1,
        pageSize: 10000,
        siteId: this.model.id
      }
      getAction('/site/produce/rule', params).then((res) => {
        if (res.success) {
          let paramList = []
          for (let i = 0; i < res.result.records.length; i++) {
            let param = res.result.records[i]
            param.key = param.id
            paramList.push(param)
          }
          that.dataProduceRule = paramList
        }
      })
    },

    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        this.devopsForm.validateFields((err1, values1) => {
          if (!err && !err1) {
            that.confirmLoading = true
            let devopsStatus = false
            let httpurl = ''
            let method = ''
            if (!this.model.id) {
              httpurl = this.url.add ? this.url.add : this.pagePath
              method = 'post'
            } else {
              httpurl = this.url.edit ? this.url.edit : this.pagePath
              method = 'put'
            }
            let formData = Object.assign(this.model, values)
            for (let i in values1) {
              if (values1[i] != undefined || values1[i] != null) {
                devopsStatus = true
              }
            }
            if (devopsStatus) {
              formData.siteInfoDevops = Object.assign(this.devopsColumns, values1)
              if (this.$refs.iwupload1) {
                formData.siteInfoDevops = this.$refs.iwupload1.getUploadListToFromData(formData.siteInfoDevops)
              }
              formData.siteInfoDevops.operationTime = formData.siteInfoDevops.operationTime ? formData.siteInfoDevops.operationTime.format('YYYY-MM-DD HH:mm:ss') : null
            }
            if (this.$refs.iwupload) {
              formData = this.$refs.iwupload.getUploadListToFromData(formData)
            }
            formData.st = this.st
            formData.siteInfoParamList = this.dataParam
            formData.siteInfoFactorList = this.dataFactor
            formData.siteInfoUserList = this.dataUser

            formData.siteProduceRuleList = this.dataProduceRule
            formData.photo = this.tempPicUrl
            formData.pictures = this.octagonal
            //时间格式化
            httpAction(httpurl, formData, method)
                .then((res) => {
                  if (res.success) {
                    that.$notification.success({
                      message: res.message
                    })
                    that.$emit('ok')
                    that.close()
                  } else {
                    that.$notification.warning({
                      message: res.message
                    })
                  }
                })
                .finally(() => {
                  that.confirmLoading = false
                })
          }
        })
      })
    },
    loadTree() {
      var that = this
      that.riverTree = []
      that.areaTree = []
      that.deptTree = []
      that.userTree = []
      that.StandardOptions = []
      that.StandardListOptions = []
      that.factorOptions = []
      // 流域
      queryRiverTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            temp.key = temp.key
            that.riverTree.push(temp)
          }
        }
      })
      // 区域
      queryAreaTreeList({
        status: '1'
      }).then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            temp.key = temp.key
            that.areaTree.push(temp)
          }
        }
      })
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
        }
      })
      // 部门
      // queryDepartTreeList().then(res => {
      //   if (res.success) {
      //     for (let i = 0; i < res.result.length; i++) {
      //       let temp = res.result[i]
      //       that.deptTree.push(temp)
      //     }
      //   }
      // }),
      // 环境标准条目
      queryStandardTreeList().then((res) => {
        if (res.success) {
          // 遍历到环境标准条目（第三层），把value前缀去掉
          for (let i = 0; i < res.result.length; i++) {
            let d1 = res.result[i]
            d1.selectable = false
            if (null !== d1.children) {
              for (let c = 0; c < d1.children.length; c++) {
                var d2 = d1.children[c]
                d2.selectable = false
                if (null !== d2.children) {
                  for (let c1 = 0; c1 < d2.children.length; c1++) {
                    let d3 = d2.children[c1]
                    d3.value = d3.value.toString().substring(3)
                  }
                }
              }
            }
            let temp = res.result[i]
            // temp.value = temp.value.toString().substring(3)
            that.StandardListOptions.push(temp)
          }
        }
      })
      // 获取所有监测因子
      let params = {
        pageNo: 1,
        pageSize: 10000,
        status: 1
      }
      queryFactorList(params).then((res) => {
        if (res.success) {
          that.factorOptions = res.result.records
        }
      })
    },
    async imgBeforeUpload(file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        return Promise.reject()
      }
      //TODO 验证文件大小
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isLt1M) {
        this.$message.warning('上传图片大小不能超过1MB!')
        return Promise.reject()
      }
      //TODO 验证图片比例
      // const isSize = new Promise((resolve, reject) => {
      // 	let img = new Image();
      // 	img.onload = () => {
      // 		let valid = img.width / img.height === 2;
      // 		resolve(valid)
      // 	}
      // 	img.src = window.URL.createObjectURL(file);
      // })
      // let a = await isSize
      // if (!a) {
      // 	this.$message.info('上传图片比例建议为2:1!');
      // 	return true
      // }
    },
    beforeUpload(file) {
      var fileType = file.type
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片')
        return false
      }
      //TODO 验证文件大小
    },
    handleChange(info) {
      this.picUrl = ''
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        var response = info.file.response
        this.uploadLoading = false
        if (response.success) {
          this.uploadFile = response.result
          this.tempPicUrl = response.result.id
          this.photourl = this.getImageView()
          this.picUrl = 'Has no pic url yet'
        } else {
          this.$notification.warning({
            message: response.message
          })
        }
      }
    },
    getImageView() {
      return this.url.imgerver + '/' + this.tempPicUrl
    },
    getImageViewComm(s) {
      return this.url.imgerver + '/' + s
    },
    getAvatarView(s) {
      return this.url.imgerver + '/' + this.octagonal[s]
    },

    /**
     * 图片上传change事件
     * @param info
     */
    handleChangeComm(s, info) {
      if (info.file.status === 'uploading') {
        this.confirmLoading = true
        return
      }
      if (info.file.status === 'done') {
        var response = info.file.response
        this.confirmLoading = false
        if (response.success) {
          this.octagonal[s] = response.result.id
          this.octagonalUrl[s + 'Url'] = true
        } else {
          this.$notification.warning({
            message: response.message
          })
        }
      }
    },

    // 查询站点参数
    queryDictByCode() {
      let that = this
      getAction('/sys/dict/getDictItems/site_st' + this.st + '_param').then((res) => {
        if (res.success) {
          var paramList = []
          for (let i = 0; i < res.result.length; i++) {
            let param = res.result[i]
            param.key = i
            param.name = param.text
            param.sort = 0
            param.dictValue = param.value
            if (that.model.id != undefined) {
              getAction('/site/info/param/' + that.model.id + '/' + param.value + '').then((res) => {
                if (res.success) {
                  if (null != res.result) {
                    param = res.result
                    param.key = param.id + i
                  }
                  param.editable = true
                  paramList.push(param)
                }
              })
            } else {
              param.editable = true
              paramList.push(param)
            }
            that.dataParam = paramList
          }
        }
      })
    },

    longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter)
    },
    coordinateOk(value) {
      if (value != null) {
        this.form.setFieldsValue({
          longitude: value[0] ? value[0] : null
        })
        this.form.setFieldsValue({
          latitude: value[1] ? value[1] : null
        })
      }
    },

    /**
     * 站点参数过滤
     * @param input
     * @param option
     * @returns {boolean}
     */
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 站点参数表格相关的操作函数
    handleChangeTable(value, key, column) {
      const newData = [...this.dataParam]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataParam = newData
      }
    },
    delTable(key) {
      const newData = this.dataParam.filter((item) => key != item.key)
      this.dataParam = newData
      this.cacheData = newData.map((item) => ({
        ...item
      }))
    },
    // 站点因子
    addTable() {
      const newData = [...this.dataFactor]
      newData.push({
        key: 'A1_' + this.addFactorDataIndex,
        factorId: '',
        restriction: '',
        lower: '',
        upper: '',
        constantNum: '',
        monitorNum: '',
        sort: '',
        editable: true
      })
      this.addFactorDataIndex = this.addFactorDataIndex + 1
      this.dataFactor = newData
      this.cacheFactorData = newData.map((item) => ({
        ...item
      }))
    },
    handleChangeFactorTable(value, key, column) {
      const newData = [...this.dataFactor]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataFactor = newData
      }
    },
    handleChangeRestriction(value, key, column) {
      const newData = [...this.dataFactor]
      const target = newData.filter((item) => key === item.key)[0]
      // const target1 = newData.filter(item => key != item.key)[0]
      if (target) {
        target[column] = value
        // 判断限制类型决定是否显示最大值、最小值
        if (value == 2 || value == 4) {
          target['upper_status'] = false
          target['lower_status'] = true
          target.lower = ' '
        } else if (value == 3 || value == 5) {
          target['upper_status'] = true
          target['lower_status'] = false
          target.upper = ' '
        } else if (value == 1) {
          target['upper_status'] = true
          target['lower_status'] = true
        } else if (value == '') {
          target['upper_status'] = false
          target['lower_status'] = false
        }
        this.dataFactor = newData
      }
    },
    delFactorTable(key) {
      const newData = this.dataFactor.filter((item) => key != item.key)
      this.dataFactor = newData
      this.cacheFactorData = newData.map((item) => ({
        ...item
      }))
    },
    editTable(key) {
      const newData = [...this.dataFactor]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target.editable = true
        this.dataFactor = newData
      }
    },
    saveTable(key) {
      const newData = [...this.dataFactor]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        delete target.editable
        this.dataFactor = newData
        this.cacheFactorData = newData.map((item) => ({
          ...item
        }))
      }
    },
    cancelTable(key) {
      const newData = [...this.dataFactor]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        Object.assign(target, this.cacheFactorData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataFactor = newData
      }
    },
    /**
     * 新增一个相关单位数组
     */
    addTable3() {
      const newData = [...this.dataUser]
      newData.push({
        key: 'A1_' + this.addUserDataIndex,
        userName: '',
        siteRole: '',
        status: '',
        editable: true
      })
      this.addUserDataIndex = this.addUserDataIndex + 1
      this.dataUser = newData
      this.cacheUserData = newData.map((item) => ({
        ...item
      }))
    },

    /**
     * 新增一个生产判断数组
     */
    addTable7() {
      const newData = [...this.dataProduceRule]
      newData.push({
        key: 'A1_' + this.addProduceRuleIndex,
        cn: '',
        config: '',
        status: '',
        sort: '',
        editable: true
      })
      this.addProduceRuleIndex = this.addProduceRuleIndex + 1
      this.dataProduceRule = newData
      this.produceRuleData = newData.map((item) => ({
        ...item
      }))
    },
    // 生产判断数组删除
    delTable7(key) {
      const newData = this.dataProduceRule.filter((item) => key != item.key)
      this.dataProduceRule = newData
      this.produceRuleData = newData.map((item) => ({...item}))
    },

    /**
     * 技术参数表格相关的操作函数
     * @param value
     * @param key
     * @param column
     */
    handleChangeTable3(value, key, column) {
      const newData = [...this.dataUser]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataUser = newData
      }
    },

    /**
     * table行输入保存
     * @param key
     */
    saveTable3(key) {
      const newData = [...this.dataUser]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        delete target.editable
        this.dataUser = newData
        this.cacheUserData = newData.map((item) => ({
          ...item
        }))
      }
    },
    /**
     * table行输入取消
     * @param key
     */
    cancelTable3(key) {
      const newData = [...this.dataUser]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        Object.assign(target, this.cacheUserData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataUser = newData
      }
    },
    /**
     * table行删除
     * @param key
     */
    delTable3(key) {
      const newData = this.dataUser.filter((item) => key != item.key)
      this.dataUser = newData
      this.cacheUserData = newData.map((item) => ({
        ...item
      }))
    },
    /**
     * table行编辑
     * @param key
     */
    editTable3(key) {
      const newData = [...this.dataUser]
      const target = newData.filter((item) => key === item.key)[0]
      if (target) {
        target.editable = true
        this.dataUser = newData
      }
    }
  }
}
</script>

<style scoped>
@import '~@assets/less/common.less';

.drawer-tool {
  margin-bottom: 10px;
}

.picture >>> .ant-upload-select-picture-card {
  width: 100%;
  height: 250px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;
  vertical-align: top;
  margin-right: 8px;
  margin-bottom: 8px;
  display: table;
}

.picture >>> .ant-upload.ant-upload-select-picture-card > .ant-upload {
  width: 100%;
  height: 100%;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  padding: 0px;
}
</style>
